import { createSelector } from 'reselect';
import { RootState } from '../store';

/** 🔒 Стабільні константи для запобігання новим посиланням */
const EMPTY_ARRAY: any[] = [];
const EMPTY_MATERIAL_ICONS: any[] = [];
const EMPTY_STRING = '';

export const selectCurrentProduct = (state: RootState) => state.curProduct.productId;

export const selectProductMaterialPrices = createSelector(
  [selectCurrentProduct],
  (product) => product?.materialPrices ?? EMPTY_ARRAY
);

export const selectSelectedMaterialFromStore = (state: RootState) =>
  state.curProduct.selectedMaterial ?? EMPTY_STRING;

export const selectCartItems = (state: RootState) => state.shoppingCart.cartItems;

export const makeSelectCartItemById = (itemId: string) =>
  createSelector([selectCartItems], (cartItems) =>
    cartItems.find((item) => item.id === itemId)
  );

export const makeSelectMaterialPricesForCartItem = (itemId: string) =>
  createSelector([selectCartItems], (cartItems) => {
    const item = cartItems.find((i) => i.id === itemId);
    return item?.product?.materialPrices ?? EMPTY_ARRAY;
  });

export const makeSelectMaterialImagesByProductId = (productId: string) =>
  createSelector(
    (state: RootState) => state.products.materialImages[productId] ?? EMPTY_ARRAY,
    (materials) => {
      if (!materials || materials.length === 0) return EMPTY_MATERIAL_ICONS;
      return materials.map(({ name, image }) => ({
        materialName: name,
        materialIcon: {
          icon: {
            publicUrl: image?.publicUrl ?? '',
          },
        },
      }));
    }
  );
